<!-- UnEnroll All modal -->
<ds-modal
  (onCloseModalEvent)="closeModal.emit(modalId)"
  [id]="modalId"
  [closeOthers]="true"
  [maxWidth]="496"
>
  <div class="row pad-horizontal-20">
    <div class="column twelve">
      <h3 class="text-center margin-bottom-20" dsContent [contentPath]="headerContentRef"></h3>
      <p class="pad-bottom-20">
        <span dsContent [contentPath]="bodyContentRef"> </span>
      </p>
    </div>
    <div>
      <br />
      <br />
    </div>

    <br />
    <br />
    @if (operators?.length > 0) {
      @for (operator of operators; track operator) {
        <div class="driver">Driver {{ operator.fullName }}</div>
      }
    }

    <p class="row pad-top-20" dsContent [contentPath]="confirmContentRef"></p>
    <div class="column twelve margin-top-20">
      <div class="row flex items-center">
        <div class="column seven">
          <button
            ds-button
            class="-outline-white"
            [attr.aria-label]="secondaryCTA"
            (click)="closeModal.emit(modalId)"
          >
            {{ secondaryCTA }}
          </button>
        </div>
        <div class="column five pad-left-20">
          <button
            ds-button
            class="-outline fill"
            (click)="unEnrollAll.emit()"
            [attr.aria-label]="primaryCTA"
          >
            {{ primaryCTA }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ds-modal>
